import {
    ComponentManager, ControlFactory,
    DetailViewContext,
    UIListener,
} from 'radpresentation.htmlclient.defaultviewextensions';
import UIListenerUtility from '@/Utils/UIListenerUtility';

class LandesverbandUIListener extends UIListener
{
    public onBeforeRender(context: DetailViewContext) {
        super.onBeforeRender(context);

        this.hideOptionsIfNotAllowed(context);
    }

    public override onDetailViewReady(context: DetailViewContext) {
        UIListenerUtility.disableControlViaOtherControl(context, 'OptionQualityMailActive', 'OptionQuailtyMailInterval');
        UIListenerUtility.disableControlViaOtherControl(context, 'OptionReminderMailActive', 'OptionReminderMailInterval');
    }

    private hideOptionsIfNotAllowed(context: DetailViewContext) {
        if (context.detailViewContextDTO.hasWriteRight === false)
        {
            const optionGroup = this.getDetailViewGroups(context, false)
                                    .filter(g => g.name.endsWith('OPTIONS'));
            if (optionGroup.length > 0)
            {
                this.removeDetailViewGroupDto(context, optionGroup[0].name);
            }
        }
    }
}

ComponentManager.setUIListener('LandesverbandUIListener', LandesverbandUIListener, 'ONVHTMLViewExtension');


